"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = require("../../Utilities");
var ColorPickerGridCell_base_1 = require("./ColorPickerGridCell.base");
var ColorPickerGridCell_styles_1 = require("./ColorPickerGridCell.styles");
exports.ColorPickerGridCell = Utilities_1.styled(ColorPickerGridCell_base_1.ColorPickerGridCellBase, ColorPickerGridCell_styles_1.getStyles, undefined, { scope: 'ColorPickerGridCell' });
//# sourceMappingURL=ColorPickerGridCell.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/SwatchColorPicker/ColorPickerGridCell.js
// module id = 1208
// module chunks = 0